import { TemplateConfig } from '../../../template-config.interface';
import { ESPN_ACCORDION_CONFIG } from '../../../shared/accordion-configs';
import { SHARED_ESPN_CONFIG, RUGBY_TEAMS } from '../shared';

export const disneyEspnRugbyUrba: TemplateConfig = {
  id: 'espn/espn-vs/rugby/urba-top-12',
  clientId: 'DISNEY',
  title: 'URBA TOP 12',
  description: 'Template ESPN deportivo',
  aspectRatio: 'vertical',
  image: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/URBA-Top-12.png',
  optimized_image: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/optimized/URBA-Top-12.png',
  video: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/previews/URBA-Top-12.mp4',

  config: {
    renderer: 'accordion',
    accordionConfig: ESPN_ACCORDION_CONFIG
  },

  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'team1',
      label: 'Equipo 1',
      type: 'select',
      options: RUGBY_TEAMS,
      defaultValue: 'alumni',
      required: true,
      allowAutocompleteInput: true,
      excludeSelectedOf: ['team2']
    },
    {
      key: 'team2',
      label: 'Equipo 2',
      type: 'select',
      options: RUGBY_TEAMS,
      defaultValue: 'regatas bella vista',
      required: true,
      allowAutocompleteInput: true,
      excludeSelectedOf: ['team1']
    },
    {
      key: 'date',
      label: 'Fecha',
      type: 'calendar',
      placeholder: 'YYYY/MM/DD',
      required: true,
      showLiveOption: true
    },
    {
      key: 'day',
      label: 'Día',
      type: 'select',
      options: SHARED_ESPN_CONFIG.days,
      defaultValue: 'domingo',
      required: true
    },
    {
      key: 'autoSyncTimes',
      label: 'Sincronizar horarios desde Argentina',
      type: 'switch',
      defaultValue: true,
      required: false
    },
    {
      key: 'region1',
      label: 'Región',
      type: 'select',
      options: SHARED_ESPN_CONFIG.regions,
      defaultValue: 'arg/uru',
      required: true
    },
    {
      key: 'time1',
      label: 'Hora',
      type: 'time',
      placeholder: '19:00',
      required: true
    },
    {
      key: 'region2',
      label: 'Región',
      type: 'select',
      options: SHARED_ESPN_CONFIG.regions,
      defaultValue: 'cl',
      required: false
    },
    {
      key: 'time2',
      label: 'Hora',
      type: 'time',
      placeholder: '21:00',
      required: false
    },
    {
      key: 'region3',
      label: 'Región',
      type: 'select',
      options: SHARED_ESPN_CONFIG.regions,
      defaultValue: 'col/pe',
      required: false
    },
    {
      key: 'time3',
      label: 'Hora',
      type: 'time',
      placeholder: '23:00',
      required: false
    },
    {
      key: 'enableRegion4',
      label: '',
      type: 'switch',
      defaultValue: false,
      required: false
    },
    {
      key: 'region4',
      label: 'Región',
      type: 'select',
      options: SHARED_ESPN_CONFIG.regions,
      defaultValue: 'mx',
      required: false
    },
    {
      key: 'time4',
      label: 'Hora',
      type: 'time',
      placeholder: '01:00',
      required: false
    },
    {
      key: 'channel',
      label: 'Canal',
      type: 'select',
      options: SHARED_ESPN_CONFIG.channels,
      defaultValue: 'espn y disney+',
      required: true
    },
    {
      key: 'tournament',
      label: 'Torneo',
      type: 'select',
      options: [{ value: 'generico', label: 'Genérico' }],
      defaultValue: 'generico',
      required: true
    }
  ],

  promptTemplate: `Haceme un asset "vs_URBA Top 12"
entre los equipos "Alumni" y "La Plata"`
};
